import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import { useAuth } from './hooks/useAuth';
import AuthPage from './pages/AuthPage';
import TicketsPage from './pages/TicketsPage';
import UsersPage from './pages/UsersPage';
import ProjectsPage from './pages/ProjectsPage';
import NavBar from './components/NavBar';
import Footer from './components/Footer';

export default function App() {
  const { user, register, login, logout, loading } = useAuth();

  if (loading) return (
    <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <Typography variant="h4" align="center">Загрузка...</Typography>
    </Container>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {user && <NavBar user={user} logout={logout} />}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Routes>
          <Route path="/" element={user ? <TicketsPage user={user} logout={logout} /> : <Navigate to="/auth" />} />
          <Route path="/ticket/:ticketWithPrefix" element={user ? <TicketsPage user={user} logout={logout} /> : <Navigate to="/auth" />} />
          <Route path="/users" element={user?.role === 'admin' ? <UsersPage /> : <Navigate to="/" />} />
          <Route path="/projects" element={user?.role === 'admin' ? <ProjectsPage /> : <Navigate to="/" />} />
          <Route path="/auth" element={!user ? <AuthPage onRegister={register} onLogin={login} /> : <Navigate to="/" />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
      {user && <Footer />}
    </Box>
  );
}
